export default __webpack_public_path__ + "static/media/egypt.ba4fdd15.png";